/**
 * The browser's `fetch`, captured at module-evaluation time — i.e. before `AnalyticsService.init()`
 * calls `datadogRum.init()`, which monkey-patches `window.fetch`.
 *
 * Why this matters: RUM's patched fetch `clone()`s and reads every response to measure timing. On a
 * long-lived telemetry stream (`RegisterReceiver`) that clone-read stalls the client's read of the
 * body — the stream connects (HTTP 200) but yields no frames, so the bootstrap `subscriberId` never
 * arrives and telemetry never flows. Passing this pristine reference to the SDK (`RocosSDK({ fetch })`)
 * reads the stream through an un-instrumented fetch.
 *
 * Both telemetry transports (Connect and grpc-web) use it with rocos-js-sdk >= 3.1.2. Bound to
 * `window` so it can be invoked as a bare function. `undefined` outside the browser.
 */
export const nativeFetch: typeof globalThis.fetch | undefined =
  typeof window !== 'undefined' && typeof window.fetch === 'function' ? window.fetch.bind(window) : undefined;
